import { render, staticRenderFns } from "./TabContainers.vue?vue&type=template&id=ecb77ee6&"
import script from "./TabContainers.vue?vue&type=script&lang=js&"
export * from "./TabContainers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports